import { latestPosts } from "@/mocks/melon";

const stats = [
  { value: "秒级", label: "榜单刷新" },
  { value: "36+", label: "今日新瓜" },
  { value: "8", label: "覆盖板块" },
  { value: "100%", label: "信源标注" },
];

function Hero() {
  const lead = latestPosts[0];
  return (
    <section id="top" className="relative scroll-mt-16 overflow-hidden">
      {/* decorative warm blobs */}
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute -top-24 right-[-6rem] h-72 w-72 rounded-full bg-primary-100/70 blur-3xl" />
        <div className="absolute top-32 left-[-5rem] h-72 w-72 rounded-full bg-accent-100/70 blur-3xl" />
        <div className="absolute inset-0 bg-gradient-to-b from-background-100/60 via-background-50 to-background-50" />
      </div>

      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 pb-14 pt-28 md:px-6 md:pb-20 md:pt-36 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-6 flex flex-col justify-center">
          <div className="inline-flex w-fit items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-semibold text-primary-700">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-500 opacity-60" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500" />
            </span>
            热搜实时追踪中
          </div>

          <h1 className="mt-5 font-heading text-3xl font-extrabold leading-tight tracking-tight text-foreground-950 md:text-5xl">
            全网热搜正在发酵，
            <br className="hidden sm:block" />
            抢先一步<span className="text-primary-600">吃上热乎瓜</span>
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            实时跟进全网热搜瓜点，今日最新爆料、正在发酵的大瓜小瓜一网打尽。随时刷新随时有更新，想第一时间吃瓜就盯紧这里，别等别人都吃完了你还没上车。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#hot"
              className="inline-flex h-12 items-center justify-center gap-2 rounded-md bg-primary-500 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
            >
              看看实时热搜
              <i className="ri-arrow-right-line text-[15px]" />
            </a>
            <a
              href="#guide"
              className="inline-flex h-12 items-center justify-center gap-2 rounded-md bg-background-100 px-6 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-200 whitespace-nowrap"
            >
              吃瓜生存指南
            </a>
          </div>

          <dl className="mt-10 grid grid-cols-2 gap-x-6 gap-y-6 sm:grid-cols-4">
            {stats.map((s) => (
              <div key={s.label} className="border-l-2 border-accent-400 pl-3">
                <dt className="text-xs text-foreground-500">{s.label}</dt>
                <dd className="mt-1 font-heading text-2xl font-extrabold text-foreground-950">{s.value}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="lg:col-span-6">
          <article className="group overflow-hidden rounded-2xl border border-background-200 bg-background-100">
            <div className="relative h-56 overflow-hidden sm:h-64 md:h-[300px]">
              <img
                src={lead.img}
                alt={lead.alt}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-black/5 to-transparent" />
              <span className="absolute left-4 top-4 rounded-md bg-accent-500 px-2.5 py-1 text-xs font-bold text-foreground-950">
                {lead.cat}
              </span>
              <span className="absolute left-4 top-4 hidden rounded-md bg-background-50/90 px-2.5 py-1 text-xs font-semibold text-foreground-700 md:left-auto md:right-4 md:inline-flex">
                爆款热读 · {lead.views}
              </span>
              <div className="absolute bottom-4 left-4 right-4">
                <h2 className="font-heading text-lg font-bold leading-snug text-white md:text-xl">{lead.title}</h2>
              </div>
            </div>
            <div className="flex items-center justify-between gap-3 border-t border-background-200 px-4 py-3 md:px-5">
              <p className="flex items-center gap-2 text-xs text-foreground-600">
                <i className="ri-time-line text-primary-600" />
                今日焦点 · {lead.excerpt.slice(0, 26)}…
              </p>
              <a
                href="#latest"
                className="inline-flex shrink-0 items-center gap-1 text-sm font-semibold text-primary-600 hover:text-primary-700 whitespace-nowrap"
              >
                去追 <i className="ri-arrow-right-line text-[14px]" />
              </a>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}

export default Hero;